import React                   from 'react';
import Alert                   from '../../shared/alert';
import Back                    from '../../shared/back';
import { ArrowLeftCircleIcon } from '../../shared/icons/icons.jsx';
import LoaderButton            from '../../shared/loader-button/loader-button.jsx';
import LocaleString            from '../../shared/locale-string';
import isEmailValid            from '../../../utils/email-validator.js';
import describedByString       from '../../../utils/describedby-string';

import './forgot-user-id.scss';

class ForgotUserId extends React.Component {
    resetFocus = false;
    state = { emailAddress: '' };

    componentWillUnmount() {
        this.props.dismissAllErrors();
        this.props.successMessage.forEach( successMsg => this.props.dismissSuccess( successMsg ) );
    }

    UNSAFE_componentWillReceiveProps( nextProps ) {//eslint-disable-line
        if ( !this.props.success && nextProps.success ) {
            this.clearInputs();
        }
    }

    UNSAFE_componentWillUpdate( nextProps ) {//eslint-disable-line
        const newErrorsLength = nextProps.errors.length;
        const oldErrorsLength = this.props.errors.length;

        this.resetFocus = ( newErrorsLength > oldErrorsLength );
    }

    componentDidUpdate() {
        if ( this.resetFocus ) {
            document.getElementById( 'emailAddress' ).focus();
            this.resetFocus = false;
        }
    }

    clearInputs = () => {
        this.setState( { emailAddress: '' } );
    };

    handleInputChange = event => {
        const name = event.target.name;
        this.setState( { [ name ]: event.target.value } );

        if ( this.props.success === true ) {
            this.props.dismissSuccess();
        }
    };

    onRequestUsernameSubmit = () => {
        const { emailAddress } = this.state;
        const {
            requestUsername,
            dismissAllErrors
        } = this.props;

        dismissAllErrors();
        requestUsername( emailAddress );
    };

    checkEnter = event => {
        const enterPressed = event.charCode === 13;
        const { emailAddress } = this.state;

        if ( enterPressed && isEmailValid( emailAddress )  ) {
            this.onRequestUsernameSubmit();
        }
    };

    render() {
        const { emailAddress } = this.state;
        const {
            busy,
            success,
            successMessage,
            errors,
            dismissError,
            dismissSuccess
        } = this.props;

        const describedByErrors = describedByString( errors, 'error' );

        return (
            <div className="forgot-user-id">
                <div className="narrow-form">

                    <div className="title" >
                        <Back className="back">
                            <ArrowLeftCircleIcon />
                        </Back>
                        <h1><LocaleString code="forgotUserId.form.headerLabel" /></h1>
                    </div>

                <label htmlFor="emailAddress">
                    <LocaleString code="forgotUserId.input.emailAddressLabel" />
                </label>
                <input
                    id="emailAddress"
                    type="email"
                    name="emailAddress"
                    value={ emailAddress }
                    required={ true }
                    onChange={ this.handleInputChange }
                    onKeyPress={ this.checkEnter }
                    disabled = { busy }
                    aria-describedby={ describedByErrors }
                />

                {
                    errors.length !== 0 && errors.map( ( error, index ) =>
                        <Alert
                            type={ 'error' }
                            onDismiss={ () => dismissError( error ) }
                            id={ `error${index}` }
                            key={ index }>
                            <p>{ error.responseMessage || error.message }</p>
                        </Alert>
                    )
                }

                {
                    successMessage.length !== 0 &&
                    <Alert
                        type={ 'success' }
                        describedBy="emailAddress"
                        onDismiss={ () => dismissSuccess( successMessage ) }>
                        <p><LocaleString code={ successMessage[ 0 ].message } /></p>
                    </Alert>
                }

                <LoaderButton
                    busy={ busy }
                    onClick={ this.onRequestUsernameSubmit }
                    disabled={ !isEmailValid( emailAddress ) || success }
                    done={ success }>
                    <LocaleString code="forgotUserId.button.submitLabel" />
                </LoaderButton>
            </div>
        </div>
        );
    }
}

export default ForgotUserId;
